<script lang="ts">
  import i18n from '../../../i18n'
  import { sceneMode } from '../../../stores/scene-mode'
  import { canvasSelection } from '../../../stores/canvas-selection'
  import Button from '../../button/Button.svelte'
  import Tooltip from '../../tooltip/Tooltip.svelte'
  import { Move3d, Rotate3d } from '@lucide/svelte'

  const hasSelection = $derived(!!$canvasSelection)

  $effect(() => {
    if (
      !$canvasSelection
      && ($sceneMode === 'translate' || $sceneMode === 'rotate')
    ) {
      sceneMode.set('default')
    }
  })

  function toggle(mode: Extract<SceneMode, 'translate' | 'rotate'>) {
    $sceneMode = $sceneMode === mode ? 'default' : mode
  }
</script>

<Tooltip title={$i18n.t('project.island.translate')}>
  <Button
    disabled={!hasSelection}
    size="icon-sm"
    variant={$sceneMode === 'translate' ? 'default' : 'ghost'}
    onclick={() => toggle('translate')}
  >
    <Move3d />
  </Button>
</Tooltip>
<Tooltip title={$i18n.t('project.island.rotate')}>
  <Button
    disabled={!hasSelection}
    size="icon-sm"
    variant={$sceneMode === 'rotate' ? 'default' : 'ghost'}
    onclick={() => toggle('rotate')}
  >
    <Rotate3d />
  </Button>
</Tooltip>
